<div *ngIf="!selectedPersonData">
  <app-select-list [title]="title" [hintText]="hintText" (textInputValueEmitter)="onSearchPersonTextChange($event)"
    [optionList]="listPersonOptions" [placeHolder]="placeHolder" [optional]="optional"
    (selectedValueEmitter)="onSearchPersonSelected($event)"
    [isLoading]="loadingPersonOptions"
    >
  </app-select-list>
</div>
<div *ngIf="selectedPersonData" class="form autocomplete ">
  <label [for]="title" [ngClass]="optional ? 'custom-label' : 'label'"> {{title}} </label>
  <input style="transform: translateY(3px);" name="disabled-person" [id]="title" type="text"
    [value]="selectedPersonData.fullName" readonly="readonly">
  <span class="back back--small u-mt10 global-hand" style="position: absolute;" (click)="onUnselect()">
    Buscar otra persona
  </span>
  <h6 class="txt txt--paragraph">&nbsp;</h6>
</div>
